export default __webpack_public_path__ + "8684fef6e6411779f0b091339f26308d.woff2";